// extracted by mini-css-extract-plugin
module.exports = {"uploadError":"MediaCard_upload--error__Sbsjh","icon":"MediaCard_icon__1rp3M"};